import { WorkLocationTypeCodes } from '@Enum/index';
import LocationValueType from '@Enum/LocationValueType.enum';

export const getLocationSymbol = (locationCode: number): LocationValueType => {
  const output =
    locationCode === WorkLocationTypeCodes.DEPARTMENT
      ? LocationValueType.DEPARTMENT
      : LocationValueType.PROJECT;
  return output;
};
